interface ExtendedDocument extends HTMLDocument {
  mozExitFullscreen?: () => void;
  mozFullScreenElement?: Element;
  msExitFullscreen?: () => void;
  msFullscreenElement?: Element;
  webkitExitFullscreen?: () => void;
  webkitFullscreenElement?: Element;
}

interface FullscreenElement extends HTMLDivElement {
  mozRequestFullScreen?: () => void;
  msRequestFullscreen?: () => void;
  webkitRequestFullscreen?: () => void;
}

export const enterFullscreen = (isMobile, playerElement, videoElement) => {
  if (playerElement) {
    const fullscreenPlayerContainer: FullscreenElement = playerElement;

    if (fullscreenPlayerContainer.requestFullscreen) {
      fullscreenPlayerContainer.requestFullscreen();
    } else if (fullscreenPlayerContainer.mozRequestFullScreen) {
      fullscreenPlayerContainer.mozRequestFullScreen();
    } else if (fullscreenPlayerContainer.webkitRequestFullscreen) {
      fullscreenPlayerContainer.webkitRequestFullscreen();
    } else if (fullscreenPlayerContainer.msRequestFullscreen) {
      fullscreenPlayerContainer.msRequestFullscreen();
    } else if (isMobile && videoElement?.webkitEnterFullscreen) {
      videoElement.webkitEnterFullscreen();
    }
  }
};

export const exitFullscreen = () => {
  try {
    const extendedDocument: ExtendedDocument = document;
    if (extendedDocument.exitFullscreen) {
      extendedDocument.exitFullscreen().catch(() => {
        /* ignore */
      });
    } else if (extendedDocument.mozExitFullscreen) {
      extendedDocument.mozExitFullscreen();
    } else if (extendedDocument.webkitExitFullscreen) {
      extendedDocument.webkitExitFullscreen();
    } else if (extendedDocument.msExitFullscreen) {
      extendedDocument.msExitFullscreen();
    }
  } catch (_) {
    /* ignore */
  }
};

export const toggleFullscreen = (element, player) => {
  if (element) {
    const fullscreenElement =
      (document as ExtendedDocument).fullscreenElement ||
      (document as ExtendedDocument).mozFullScreenElement ||
      (document as ExtendedDocument).webkitFullscreenElement ||
      (document as ExtendedDocument).msFullscreenElement;

    if (!fullscreenElement) {
      player.enterFullscreen();
    } else {
      exitFullscreen();
    }
  }
};
